import React, {useState} from "react";
import { Row, Col } from "react-flexbox-grid";
import { Formik } from "formik";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import DetailsSection from "./details-section";
import SelectTags from "./selectTags";
import BorderZone from "../../border-zone";

const styles = theme => ({
  textField: {
    marginLeft  : theme.spacing.unit,
    marginRight : theme.spacing.unit
  },
  button: {
    margin: theme.spacing.unit * 2,
  },
  panel : {
    marginLeft : 12,
  }
});

const BasicInformation = props => {
  const {
    indicator,
    indicatorId,
    classes,
    onSubmit,
    title=true
  } = props;
  const defaultTags               = indicator && indicator.tags ? indicator.tags.map(item => item._id) : [];
  const [indicatorTypes, setTags] = useState(defaultTags);

  return (
    <DetailsSection title={title ? "Información básica" : ''}>
      <Formik
        initialValues={{
          name: indicator ? indicator.name : '',
          description: indicator ? indicator.description : '',
          paletteType: indicator ? indicator.paletteType : ''
        }}
        validate={values => {
          let errors = {};
          if (!values.name) {
            errors.name = "Requerido";
          }
          if (!values.paletteType) {
            errors.paletteType = "Requerido";
          }
          return errors;
        }}
        onSubmit={(values, bag) => {
          let mappedFileValuesGeneralities = [];
          let mappedFileValuesInequalities = [];

          if(props.indicator && props.indicator.generalities){
            mappedFileValuesGeneralities = Object.assign({}, props.indicator.generalities, {
              files : props.indicator.generalities.files.map(file => file.id),
            });
          }
          if(props.indicator && props.indicator.inequalities){
            mappedFileValuesInequalities = Object.assign({}, props.indicator.inequalities, {
              files : props.indicator.inequalities.files.map(file => file.id),
            });
          }

          const newValues = Object.assign({}, props.indicator, {
            name: values.name,
            description: values.description,
            paletteType: values.paletteType,
            generalities : mappedFileValuesGeneralities,
            inequalities : mappedFileValuesInequalities,
            tags : indicatorTypes,
          });
          onSubmit({
            variables: { id: indicatorId, indicator: newValues }
          }).then(() => {
            bag.setSubmitting(false);
          });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting
        }) => {
          return (
            <form autoComplete="off" onSubmit={handleSubmit}>
              <BorderZone>
                <Row style={{ marginRight: 10 }}>
                    <Col xs={12} md={6}>
                      <TextField
                        required
                        name="name"
                        id="outlined-name"
                        label="Nombre"
                        className={classes.textField}
                        value={values.name}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        error={errors.name && touched.name && errors.name}
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <TextField
                        id="outlined-select-currency"
                        select
                        name="paletteType"
                        label="Tipo de paleta"
                        className={classes.textField}
                        value={values.paletteType}
                        onChange={handleChange}
                        helperText="Seleccione tipo de paleta"
                        margin="normal"
                        variant="outlined"
                        error={
                          errors.paletteType &&
                          touched.paletteType &&
                          errors.paletteType
                        }
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                      >
                        <MenuItem value="DIVERGENT">Divergente</MenuItem>
                        <MenuItem value="SEQUENTIAL">Secuencial</MenuItem>
                        <MenuItem value="INVERTED_SEQUENTIAL">Secuencial Invertido</MenuItem>
                      </TextField>
                    </Col>
                    <Col xs={12} md={12}>
                      <TextField
                        required
                        name="description"
                        id="outlined-name"
                        label="Descripción"
                        multiline
                        className={classes.textField}
                        value={values.description}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        error={
                          errors.description &&
                          touched.description &&
                          errors.description
                        }
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <SelectTags
                        tags     = {indicator && indicator.tags ? indicator.tags : []}
                        selected = {(selected) => setTags(selected)}
                      />
                    </Col>
                </Row>
              </BorderZone>
              <Row end="xs">
                <Col xs>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Guardar Información básica
                  </Button>
                </Col>
              </Row>
            </form>
          );
        }}
      </Formik>
    </DetailsSection>
  );
};

export default withStyles(styles)(BasicInformation);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/basic-information.js